export const defaultHeaders = [
  {
    text: "Наименование",
    sortable: true,
    key: "name",
  },
  {
    text: "Загрузка",
    sortable: false,
    key: "download",
  },
];
